module.exports = __webpack_public_path__ + "img/qr.6cdbffbb.jpg";